export const toUniqueCollection = <T>(array: T[], comparer = (el: T) => JSON.stringify(el)) => {
  const result = [];
  const map = new Map();
  for (const item of array) {
    if (!map.has(comparer(item))) {
      map.set(comparer(item), true);
      result.push(item);
    }
  }
  return result;
};
